import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-1of4 _mb-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_notification = _resolveComponent("skeleton-notification")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")
  const _component_slider_container = _resolveComponent("slider-container")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_skeleton_line, { height: 18 })
    ]),
    _createVNode(_component_slider_container, {
      "display-arrows": false,
      centered: false,
      "slides-wrapper-class": "gfu-pending-actions-wrapper",
      "slides-class": "gfu-pending-actions-slides",
      "data-qa": "skeleton-pending-actions-slider"
    }, {
      header: _withCtx(() => [...(_cache[0] || (_cache[0] = []))]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.itemCount, (n) => {
          return (_openBlock(), _createElementBlock("div", {
            key: n,
            class: "gfu-pending-action gfu-11of12 gfu-3of4--m gfu-1of2--l _shrink-0 _grow-0"
          }, [
            _createVNode(_component_skeleton_wrapper, { class: "_fov" }, {
              default: _withCtx(() => [
                _createVNode(_component_skeleton_notification)
              ]),
              _: 1 /* STABLE */
            })
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}